import {
  FileTextIcon,
  ZapIcon,
  LanguagesIcon,
  SmartphoneIcon,
  ShieldCheckIcon,
  LockIcon,
  CreditCardIcon,
} from 'lucide-react';

export const heroChips = [
  { icon: FileTextIcon, label: '100% PDF' },
  { icon: ZapIcon, label: 'Accès instantané' },
  { icon: LanguagesIcon, label: 'Depuis zéro absolu' },
  { icon: SmartphoneIcon, label: 'Android & iOS' },
];

export const heroTrust = [
  { icon: ShieldCheckIcon, label: 'Garantie 7 jours' },
  { icon: LockIcon, label: 'Paiement sécurisé' },
  { icon: CreditCardIcon, label: 'Carte crédit / débit' },
  { icon: ZapIcon, label: 'Accès instantané' },
];

export const stats = [
  { value: '500+', label: 'Étudiants heureux ⭐' },
  { value: '6', label: 'Tomes complets' },
  { value: '5', label: 'Bonus inclus' },
  { value: '4.9/5', label: 'Note' },
];
